module.exports = {"title":"Tickets Assignment","noChange":"No changes","both":"Patron and Box Office","boxOfficeOnly":"Box Office only","noOne":"No one","saveClose":"Save and Close"}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/GlobalPriceModal/locales/en.json
// module id = 1669
// module chunks = 0